<template>

    <header class="confi">
        <div class="container">
            <div class="logo">
                <span class="shape"></span>
                <span class="text"></span>
            </div>
            <div class="step-wrapper" ref="stepWrapper" :class="{ rdy : navInit }">

                <router-link tag="div" to="/infos" class="step-outer" :class="{ done : Global.currentConfigStep > 1}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">1</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[0] + 'px' }">Your informations</span>
                </router-link>

                <div class="sep-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <router-link tag="div" to="/content" class="step-outer" :class="{ done : Global.currentConfigStep > 2}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">2</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[1] + 'px' }">Content</span>
                </router-link>

                <div class="sep-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <router-link tag="div" to="/model" class="step-outer" :class="{ done : Global.currentConfigStep > 3}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">3</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[2] + 'px' }">Business models</span>
                </router-link>

                <div class="sep-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <router-link tag="div" to="/look" class="step-outer" :class="{ done : Global.currentConfigStep > 4}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">4</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[3] + 'px' }">Look & feel</span>
                </router-link>

                <div class="sep-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <router-link tag="div" to="/services" class="step-outer" :class="{ done : Global.currentConfigStep > 5}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">5</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[4] + 'px' }">Additionnal services</span>
                </router-link>

                <div class="sep-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <router-link tag="div" to="/payment" class="step-outer" :class="{ done : Global.currentConfigStep > 6}">
                    <div class="shape">
                        <span class="main"></span>
                        <div class="inner">
                            <span class="num ft-xbld">6</span>
                            <span class="checker"></span>
                        </div>
                    </div>
                    <span class="txt ft-bld" :style="{ width : navStorage[5] + 'px' }">Payment</span>
                </router-link>

            </div>
            <button class="btn main cart" :class="{ dslbd : Global.currentConfigStep > 6, active : openedCart }" @click.prevent="toggleCart" ref="outerCart">
                <div class="prw">
                    <div class="ctnt">
                        <span>Your price</span>
                        <span><span class="ft-xbld prce">{{ cartTotal }}€</span><span>/month</span></span>
                    </div>
                    <span class="arw"></span>
                </div>
                <div class="extend">
                    <span class="cap-title ft-xbld">Your cart</span>
                    <div class="line" v-for="row, index in cartRows" :key="index">
                        <span class="caption">{{ row.label }}</span>
                        <span class="price ft-blk">{{ row.price }}€</span>
                    </div>
                    <div class="line w-price">
                        <span class="caption">Your final price</span>
                        <div class="price-outer">
                            <span class="ft-xbld prce">{{ cartTotal }}€</span>
                            <span>/month</span>
                        </div>
                    </div>
                </div>
            </button>
        </div>
    </header>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'ConfigHeadbar',

        data() {
            return {
                Global,
                navStorage: [],
                navInit: false,
                openedCart: false
            }
        },

        computed: {

            cartRows() {
                return [
                    this.cartPackage,
                    ...this.cartServices
                ]
            },

            cartPackage() {
                
                let pack = {}

                switch(this.Global.cart.package) {
                    case "nurse":
                        pack = {
                            label: "Nurse Package",
                            price: Global.products.nurse.price
                        }
                        break;
                    default:
                    case "architect":
                        pack = {
                            label: "Architect Package",
                            price: Global.products.architect.price
                        }
                        break;
                    case "guardian":
                        pack = {
                            label: "Guardian Package",
                            price: Global.products.guardian.price
                        }
                        break;
                }

                if(this.Global.cart.isYearly) {
                    pack.price =  Math.floor(((90/ 100) * pack.price))
                }

                return pack
            },

            cartServices() {
                return [
                    this.Global.mockupConfig.services.recommendation ?
                    {label: "Recommendation", price: Global.products.recommendation.price} : null,
                    this.Global.mockupConfig.services.content_protection ?
                    {label: "Advanced content protection", price: Global.products.content_protection.price} : null,
                    this.Global.mockupConfig.services.content_tagging ?
                    {label: "Content tagging", price: Global.products.content_tagging.price} : null,
                    this.Global.mockupConfig.services.content_enrichment ?
                    {label: "Rich Metadata & Content enrichment", price: Global.products.content_enrichment.price} : null
                ].filter((service) => service !== null)
            },

            cartTotal() {
                let total = 0
                for(let row of this.cartRows) {
                    total += row.price
                }
                return total
            }
        },

        mounted() {
            document.body.addEventListener('click', this.bodyClick)
            // this.$nextTick(() => { this.stepInit() });
            setTimeout(() => { this.stepInit() }, 100)
        },

        methods: {

            getComputed(el,prop){
                if (!el) return
                return parseInt(window.getComputedStyle(el, null).getPropertyValue(prop))
            },

            stepInit() {
                let wrapper = this.$refs.stepWrapper
                let itemsCount = wrapper.getElementsByClassName('step-outer').length
                let item = wrapper.getElementsByClassName('step-outer')
                // let test = this.getComputed(item[0].getElementsByClassName('txt')[0],'width')
                // console.log(item[0].getElementsByClassName('txt')[0].clientWidth)
                // console.log(test)
                for (let i = 0; i < itemsCount; i++)
                    this.navStorage.push(item[i].getElementsByClassName('txt')[0].clientWidth)
                // console.log(this.navStorage)
                this.navInit = true
            },

            toggleCart(){
                this.openedCart = !this.openedCart
            },

            bodyClick(event) {
                if (!this.openedCart || this.Global.currentConfigStep == 5) return
                let el = '.' + this.$refs.outerCart.classList[2] + ' *'
                if (!event.target.matches(el))
                    this.openedCart = false
            },
            

        },

        beforeDestroy() {
            document.body.removeEventListener('click', this.bodyClick)
        }

    }

</script>